import { AmplitudeProductType } from 'Src/models/Amplitude/ProductTypes';

import { AMPLITUDE_PROVIDER } from '../providers';
import { AnalyticsManager } from '../AnalyticsManager';

/* eslint-disable camelcase */
export interface LoginAmplitudeEvent {
  application_id?: string | null;
  error_message?: string | null;
  is_embedded_amz?: boolean;
  kueski_user_id?: string | null;
  merchant_id?: string;
  merchant_name?: string;
  payment_id?: string | null;
  payment_intent_id?: string | null;
  product_type?: AmplitudeProductType | null;
  purchase_amount?: string;
  recurrent?: boolean;
}
/* eslint-enable camelcase */
export function sendLoginCompleted(event: LoginAmplitudeEvent) {
  const analytics = new AnalyticsManager();
  analytics.addProvider(AMPLITUDE_PROVIDER);
  analytics.sendEvent('log_in_completed', { ...event, app_source: 'kpay' });
}

export function sendLoginErrorCompleted(event: LoginAmplitudeEvent) {
  const analytics = new AnalyticsManager();
  analytics.addProvider(AMPLITUDE_PROVIDER);
  analytics.sendEvent('error_log_in_completed', { ...event, app_source: 'kpay' });
}
